import api from './api';

import {CHANNELS_SET_ACTIVE} from './channels';

export const SEARCH_FETCH_PRODUCTS = 'SEARCH_FETCH_PRODUCTS';
export const SEARCH_SET_PRODUCTS = 'SEARCH_SET_PRODUCTS';
export const SEARCH_ERROR_PRODUCTS = 'SEARCH_ERROR_PRODUCTS';

const PRODUCTS_LIMIT = 4;

const initialState = {};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case SEARCH_FETCH_PRODUCTS:
      return {
        ...state,
        [payload.query]: {
          ...(state[payload.query] || {total: -1, loaded: 0, items: []}),
          isLoading: true,
          error: false,
          page: payload.page
        }
      };
    case SEARCH_SET_PRODUCTS:
      return {
        ...state,
        [payload.query]: {
          ...state[payload.query],
          total: payload.total,
          isLoading: false,
          error: false,
          page: payload.page,
          loaded: state[payload.query].loaded + payload.items.length,
          items: state[payload.query].items.concat(payload.items)
        }
      };
    case SEARCH_ERROR_PRODUCTS:
      return {
        ...state,
        [payload.query]: {
          ...(state[payload.query] || {}),
          isLoading: false,
          error: true,
          page: Math.min(1, payload.page - 1)
        }
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function fetchSearchByQuery(query, page = 1, limit = PRODUCTS_LIMIT) {
  return dispatch => {
    dispatch({type: SEARCH_FETCH_PRODUCTS, payload: {query, page}});

    return dispatch(api.get(`products/`, {query, page, limit}, {cache: 'default'}))
      .then(
        searchResponse => dispatch({
          type: SEARCH_SET_PRODUCTS,
          payload: {query, page, total: searchResponse.meta.total, items: searchResponse.content.items}
        }),
        searchError => {
          dispatch({
            type: SEARCH_ERROR_PRODUCTS,
            payload: {query, page}
          });

          throw searchError;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./ducks/search.js